<template>
  <div class="lcmb-container">
    <el-row class="tcf-row">
      <el-col  class="card">
        <div class="card-body">
          <div class="card-title">
            <div class="search-mode">
              <el-form :inline="true" size="small" :model="searchForm" @submit.native.prevent>
                <el-form-item label="搜索关键字">
                  <el-input v-model="searchForm.search" placeholder="请输入关键字" @keyup.enter.native="Search"></el-input>
                </el-form-item>
                <el-form-item>
                  <el-button icon="el-icon-search" @click="Search">搜索</el-button>
                </el-form-item>
                <el-form-item style="float: right">
                  <el-button class="plus-btn"  type="primary" size="mini" icon="el-icon-plus" @click="editTemplate(null)">新建模板</el-button>
                </el-form-item>
              </el-form>
            </div>
            <div class="card-content" v-loading="loading">
              <el-table
                :data="tableData"
                stripe
                style="width: 100%;margin-bottom: 20px">
<!--                <el-table-column-->
<!--                  prop="imgurl"-->
<!--                  label="封面"-->
<!--                  width="160"-->
<!--                  show-overflow-tooltip>-->
<!--                  <template slot-scope="scope">-->
<!--                    <el-image-->
<!--                      :src="scope.row.imgurl"-->
<!--                      fit="cover"-->
<!--                      style="width: 77px;height: 40px;"-->
<!--                      :preview-src-list="[scope.row.imgurl]">-->
<!--                    </el-image>-->
<!--                  </template>-->
<!--                </el-table-column>-->
                <el-table-column
                  prop="temname"
                  label="模板名称"
                  width="160"
                  show-overflow-tooltip>
                </el-table-column>
                <el-table-column
                  prop="explain"
                  label="模板说明"
                  min-width="160"
                  show-overflow-tooltip>
                </el-table-column>
<!--                <el-table-column-->
<!--                  prop="abbname"-->
<!--                  label="所属组织"-->
<!--                  width="160"-->
<!--                  align="center"-->
<!--                  show-overflow-tooltip>-->
<!--                </el-table-column>-->
                <el-table-column
                  label="事项数"
                  width="120"
                  show-overflow-tooltip>
                  <template slot-scope="scope">
                    <span style="color: #409EFF;font-weight: bold"><i class="el-icon-s-flag"></i> {{scope.row.tasklist.length}}</span>
                  </template>
                </el-table-column>
                <el-table-column
                  prop="username"
                  label="创建人"
                  width="120"
                  show-overflow-tooltip>
                </el-table-column>
                <el-table-column
                  prop="time"
                  label="创建时间"
                  width="160"
                  show-overflow-tooltip>
                </el-table-column>
                <el-table-column
                  label="操作"
                  width="200"
                  align="center"
                  fixed="right"
                  show-overflow-tooltip>
                  <template slot-scope="scope">
                    <el-button icon="el-icon-edit" size="mini" @click="editTemplate(scope.row)">修改</el-button>
                    <el-button icon="el-icon-delete" size="mini" @click="deleteTemplate(scope.row)">删除</el-button>
                  </template>
                </el-table-column>
              </el-table>
            </div>
            <el-pagination
              v-if="total>0"
              background
              @size-change="handleSizeChange"
              @current-change="handleCurrentChange"
              :current-page="currentPage"
              :page-sizes="[20, 50, 100]"
              :page-size="pageSize"
              layout="total, sizes, prev, pager, next, jumper"
              :total="total">
            </el-pagination>
          </div>
        </div>
      </el-col>
    </el-row>
    <el-dialog
      :title="editTitle"
      :visible.sync="editInfoVisible"
      width="70%"
      top="10vh"
      :destroy-on-close="true"
      :lock-scroll="true"
      :close-on-click-modal="false"
      :append-to-body="true">
      <el-form ref="eForm" :model="eForm"  :rules="eFormRules" label-position="right" label-width="80px" size="small">
<!--        <el-form-item label="模板封面" prop="img">-->
<!--          <SingleImg :key="imgKey" v-model="eForm.img" :oldurl="eForm.oldimgurl" :size="[320,200]"></SingleImg>-->
<!--        </el-form-item>-->
        <el-form-item label="名称" prop="temname">
          <el-input v-model="eForm.temname" clearable maxlength="100" style="width: 100%" show-word-limit />
        </el-form-item>
        <el-form-item label="说明" prop="explain">
          <el-input
            style="width: 100%"
            v-model="eForm.explain"
            maxlength="300"
            type="textarea"
            :rows="2"
            clearable
            show-word-limit/>
        </el-form-item>
        <el-form-item label="阶段" prop="stage">
          <el-tag type="info">未开始</el-tag>
          <el-tag
            :key="tag"
            v-for="tag in eForm.flowStageList"
            closable
            :disable-transitions="false"
            @close="handleClose(tag)">
            {{tag}}
          </el-tag>
          <el-input
            class="input-new-tag"
            v-if="inputVisible"
            v-model="inputValue"
            ref="saveTagInput"
            maxlength="20"
            size="small"
            @keyup.enter.native="handleInputConfirm"
            @blur="handleInputConfirm"
          >
          </el-input>
          <el-button v-else class="button-new-tag" size="small" @click="showInput">+ 添加阶段</el-button>
          <el-tag type="info">已完成</el-tag>
        </el-form-item>
        <el-form-item label="事项" prop="task">
          <span style="color:#99a9bf;font-size: 12px"><i class="el-icon-info"></i> 有前提条件的事项必须在前提条件所有事项完成后才可产生</span>
          <div class="task-main">
            <div class="task-box" :style="`width: ${tasklevel*220}px`">
              <div class="task-level" v-for="l in tasklevel">
                <div v-for="t in eForm.taskList" :class="t.isgreen?'task task-green':'task'" @mouseover="showGreen(t)" @mouseleave="hideGreen(t)" v-if="t.level===l">
                  <div class="task-header">
                    <div class="xh">{{t.xh}}</div>
                    <span>{{t.name}}</span>
                    <div class="edit" @click="editTask(t)"><i class="el-icon-edit-outline"></i></div>
                    <div class="close" @click="delTask(t)"><i class="el-icon-close"></i></div>
                  </div>
                  <div class="task-foot" v-if="t.level>1">
                    <div class="tit">前提条件：</div>
                    <div class="c" v-for="q in t.opencond">
                      <span v-for="t1 in eForm.taskList" v-if="t1.id===q">{{t1.xh}}</span>
                    </div>
                  </div>
                </div>
                <div class="add-task" @click="addTask(l)"><i class="el-icon-plus"></i> 添加事项</div>
              </div>
            </div>
          </div>
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
          <el-button  type="primary" size="small" :loading="subLoading" @click="createOrEditTemplate('eForm')">立即提交</el-button>
        <el-button size="small" @click="editInfoVisible = false">取消</el-button>
      </span>
    </el-dialog>
    <el-dialog
      :title="editTaskTitle"
      :visible.sync="editTaskVisible"
      width="400px"
      :destroy-on-close="true"
      :lock-scroll="true"
      :close-on-click-modal="true"
      :append-to-body="true">
      <el-form ref="taskForm" :model="taskForm"  :rules="taskFormRules" label-position="right" label-width="80px" size="small">
        <el-form-item label="前提条件" prop="opencond" v-if="taskForm.level>1">
          <el-select v-model="taskForm.opencond" multiple placeholder="请选择" style="width: 100%">
            <el-option
              v-for="item in opencondOptions"
              :key="item.id"
              :label="item.name"
              :value="item.id">
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="事项名称" prop="name">
          <el-input v-model="taskForm.name" clearable maxlength="100" style="width: 100%" show-word-limit />
        </el-form-item>
        <el-form-item label="事项说明" prop="remark">
          <el-input
            v-model="taskForm.remark"
            maxlength="300"
            type="textarea"
            :rows="2"
            clearable
            show-word-limit/>
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button  type="primary" size="small" @click="subTask">确定</el-button>
        <el-button size="small" @click="editTaskVisible = false">取消</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import { getUser } from '@/utils/auth'
import { createOrEditTemplate, selectTemplateData, deleteByIdFlowTemplate } from '@/api/work'
import qs from 'qs'
import { guid } from '@/utils/index'
// import SingleImg from '@/components/upload/SingleImg'
export default {
  name: 'lcmb',
  computed: {
    user: getUser
  },
  // components: {
  //   SingleImg
  // },
  data() {
    const validateStage = (rule, value, callback) => {
      if (this.eForm.flowStageList.length <= 0) {
        callback(new Error('至少添加一个阶段'))
      } else {
        callback()
      }
    }
    const validateTask = (rule, value, callback) => {
      if (this.eForm.taskList.length <= 0) {
        callback(new Error('至少添加一个事项'))
      } else {
        callback()
      }
    }
    const validateOpencond = (rule, value, callback) => {
      if (this.taskForm.opencond.length <= 0) {
        callback(new Error('至少选择一个前提条件'))
      } else {
        callback()
      }
    }
    return {
      editTitle: '',
      editInfoVisible: false,
      loading: false,
      subLoading: false,
      imgKey: null,
      searchForm: {
        search: ''
      },
      currentPage: 1,
      pageSize: 20,
      total: 0,
      tableData: [],
      eForm: {
        ftid: null,
        // img: null,
        // oldimgurl: '',
        temname: null,
        explain: null,
        flowStageList: [],
        taskList: []
      },
      tasklevel: 1,
      opencondOptions: [],
      eFormRules: {
        // img: [{ required: true, message: '封面不能为空', trigger: 'change' }],
        temname: [{ required: true, message: '模板名称不能为空', trigger: 'blur' }],
        // explain: [{ required: true, message: '模板说明不能为空', trigger: 'blur' }],
        stage: [{ required: true, trigger: 'change', validator: validateStage }],
        task: [{ required: true, trigger: 'change', validator: validateTask }]
      },
      inputVisible: false,
      inputValue: '',
      taskForm: {
        xh: 0,
        id: '',
        name: '',
        remark: '',
        level: 0,
        opencond: []
      },
      taskFormRules: {
        name: [{ required: true, message: '事项名称不能为空', trigger: 'blur' }],
        opencond: [{ required: true, trigger: 'change', validator: validateOpencond }]
      },
      editTaskTitle: '',
      editTaskVisible: false
    }
  },
  created() {
    this.getData()
  },
  methods: {
    showGreen(t) {
      for (const o of t.opencond) {
        for (let te of this.eForm.taskList) {
          if (o === te.id) {
            te.isgreen = true
          }
        }
      }
    },
    hideGreen(t) {
      for (const o of t.opencond) {
        for (let te of this.eForm.taskList) {
          if (o === te.id) {
            te.isgreen = false
          }
        }
      }
    },
    delTask(t) {
      let isok = true
      for (const te of this.eForm.taskList) {
        for (const o of te.opencond) {
          if (o === t.id) {
            isok = false
            break
          }
        }
        if (!isok) {
          break
        }
      }
      if (isok) {
        this.$confirm('您确定要删除此事项吗?', '删除事项', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(() => {
          this.eForm.taskList.splice(this.eForm.taskList.indexOf(t), 1)
          let _tasklevel = 1
          for (const t of this.eForm.taskList) {
            if (t.level > _tasklevel) {
              _tasklevel = t.level
            }
          }
          this.tasklevel = _tasklevel + 1
        })
      } else {
        this.$message({
          type: 'error',
          message: '该事项已是其他事项的前提条件'
        })
      }
    },
    editTask(t) {
      this.taskForm = {
        xh: t.xh,
        id: t.id,
        name: t.name,
        remark: t.remark,
        level: t.level,
        opencond: t.opencond
      }
      if (this.taskForm.level > 1) {
        let _opencondOptions = []
        for (const t of this.eForm.taskList) {
          if (t.level === this.taskForm.level - 1) {
            _opencondOptions.push({ id: t.id, name: t.name })
          }
        }
        this.opencondOptions = _opencondOptions
      } else {
        this.opencondOptions = []
      }
      this.editTaskTitle = '编辑事项'
      this.editTaskVisible = true
    },
    subTask() {
      this.$refs['taskForm'].validate((valid) => {
        if (valid) {
          if (this.editTaskTitle === '编辑事项') {
            for (let t of this.eForm.taskList) {
              if (t.xh === this.taskForm.xh && t.id === this.taskForm.id) {
                t.name = this.taskForm.name
                t.remark = this.taskForm.remark
                t.opencond = this.taskForm.opencond
              }
            }
          } else {
            this.eForm.taskList.push({
              xh: this.taskForm.xh,
              id: this.taskForm.id,
              name: this.taskForm.name,
              remark: this.taskForm.remark,
              level: this.taskForm.level,
              opencond: this.taskForm.opencond,
              isgreen: false
            })
            let _tasklevel = 1
            for (const t of this.eForm.taskList) {
              if (t.level > _tasklevel) {
                _tasklevel = t.level
              }
            }
            this.tasklevel = _tasklevel + 1
          }
          this.editTaskVisible = false
        }
      })
    },
    addTask(n) {
      this.taskForm.id = guid()
      let xh = 1
      if (this.eForm.taskList.length > 0) {
        xh = this.eForm.taskList[this.eForm.taskList.length - 1].xh + 1
      }
      this.taskForm.xh = xh
      this.taskForm.name = ''
      this.taskForm.remark = ''
      this.taskForm.opencond = []
      this.taskForm.level = n
      if (this.taskForm.level > 1) {
        let _opencondOptions = []
        for (const t of this.eForm.taskList) {
          if (t.level === this.taskForm.level - 1) {
            _opencondOptions.push({ id: t.id, name: t.name })
          }
        }
        this.opencondOptions = _opencondOptions
      } else {
        this.opencondOptions = []
      }
      this.editTaskTitle = '添加事项'
      this.editTaskVisible = true
    },
    handleClose(tag) {
      this.eForm.flowStageList.splice(this.eForm.flowStageList.indexOf(tag), 1)
    },
    showInput() {
      this.inputVisible = true
      this.$nextTick(_ => {
        this.$refs.saveTagInput.$refs.input.focus()
      })
    },
    handleInputConfirm() {
      let inputValue = this.inputValue
      if (inputValue) {
        this.eForm.flowStageList.push(inputValue)
      }
      this.inputVisible = false
      this.inputValue = ''
    },
    Search() {
      if (this.searchForm.search != null && this.searchForm.search.trim() != '') {
        this.currentPage = 1
        this.getData()
      } else {
        this.searchForm.search = ''
        this.getData()
      }
      this.getData()
    },
    deleteTemplate(row) {
      this.$confirm('您确定要删除此模板吗?', '删除提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        this.loading = true
        deleteByIdFlowTemplate({ ftid: row.ftid }).then(response => {
          this.$message({
            type: 'success',
            message: response.msg
          })
          this.getData()
        }).catch(() => {
          this.loading = false
        })
      })
    },
    handleSizeChange(val) {
      this.pageSize = val
      this.currentPage = 1
      this.getData()
    },
    handleCurrentChange(val) {
      this.currentPage = val
      this.getData()
    },
    getData() {
      this.loading = true
      const data = {
        groupid: this.user.dGroupid,
        page: this.currentPage,
        limit: this.pageSize,
        content: this.searchForm.search
      }
      selectTemplateData(data).then(response => {
        this.tableData = response.data
        this.total = response.total
        this.loading = false
      })
    },
    createOrEditTemplate(fromName) {
      this.$refs[fromName].validate((valid) => {
        if (valid) {
          if (!this.subLoading) {
            this.subLoading = true
            const data = {
              ftid: this.eForm.ftid,
              // imgid: this.eForm.img.imgid,
              temname: this.eForm.temname,
              explain: this.eForm.explain,
              userid: this.user.dUserid,
              groupid: this.user.dGroupid,
              flowStageList: qs.parse(this.eForm.flowStageList),
              taskList: qs.parse(this.eForm.taskList)
            }
            createOrEditTemplate(data).then(response => {
              this.$message({
                message: response.msg,
                type: 'success'
              })
              this.editInfoVisible = false
              this.subLoading = false
              this.getData()
            }).catch(() => {
              this.subLoading = false
            })
          }
        }
      })
    },
    editTemplate(row) {
      if (row === null) {
        // this.imgKey = new Date().getTime() + 2
        this.eForm.ftid = 0
        // this.eForm.img = null
        // this.eForm.oldimgurl = null
        this.eForm.temname = null
        this.eForm.explain = null
        this.eForm.flowStageList = ['进行中']
        this.eForm.taskList = []
        this.editTitle = '新建模板'
        this.tasklevel = 1
      } else {
        this.eForm.ftid = row.ftid
        this.eForm.temname = row.temname
        this.eForm.explain = row.explain
        let _flowStageList = []
        for (const stage of row.stagelist) {
          _flowStageList.push(stage.stagename)
        }
        this.eForm.flowStageList = _flowStageList
        let _taskList = []
        let xh = 1
        for (const task of row.tasklist) {
          _taskList.push({
            xh: xh,
            id: task.stid,
            name: task.taskname,
            remark: task.remark,
            level: task.level,
            opencond: task.opencond.split(','),
            isgreen: false
          })
          xh++
        }
        this.eForm.taskList = _taskList
        this.editTitle = '修改模板'
        let _tasklevel = 1
        for (const t of this.eForm.taskList) {
          if (t.level > _tasklevel) {
            _tasklevel = t.level
          }
        }
        this.tasklevel = _tasklevel + 1
      }
      this.editInfoVisible = true
    }
  }
}
</script>

<style lang="scss" scoped>
.el-tag + .el-tag {
  margin-left: 10px;
}
.button-new-tag {
  margin-left: 10px;
  height: 32px;
  line-height: 30px;
  padding-top: 0;
  padding-bottom: 0;
  margin-right: 10px;
}
.input-new-tag {
  width: 90px;
  margin-left: 10px;
  vertical-align: bottom;
  margin-right: 10px;
}
.task-main{
  width: 100%;
  position: relative;
  overflow: auto;
  background: #f5f7fa;
  .task-box{
    position: relative;
    box-sizing: border-box;
    padding: 10px 0;
    &:after{
      display: table;
      content: "";
      clear: both;
    }
    &:before{
      display: table;
      content: "";
    }
    .task-level{
      width: 220px;
      float: left;
      box-sizing: border-box;
      padding: 0 10px;
    }
    .add-task{
      width: 200px;
      height: 40px;
      line-height: 40px;
      position: relative;
      background-color: #fff;
      border-radius: 4px;
      border: 1px dashed #ebebeb;
      text-align: center;
      font-size: 12px;
      cursor: pointer;
      &:hover{
        color: #409EFF;
        border: 1px dashed #409EFF;
      }
    }
    .task{
      width: 200px;
      position: relative;
      background-color: #fff;
      border-radius: 4px;
      border: 1px solid #ebebeb;
      margin-bottom: 10px;
      cursor: pointer;
      &:hover{
        box-shadow: 0 2px 12px 0 rgba(64, 158, 255,0.6);
      }
      .task-header{
        width: 100%;
        height: 40px;
        line-height: 40px;
        position: relative;
        padding: 0 50px 0 30px;
        overflow: hidden;
        font-size: 12px;
        text-overflow: ellipsis;
        white-space: nowrap;
        .xh{
          width: 16px;
          height: 16px;
          background: #409EFF;
          position: absolute;
          color: #fff;
          line-height: 16px;
          border-radius: 50%;
          font-weight: bold;
          font-size: 11px;
          top: 12px;
          left: 10px;
          text-align: center;
        }
        span{
          font-weight: bold;
        }
        .edit{
          width: 20px;
          height: 20px;
          text-align: center;
          line-height: 20px;
          position: absolute;
          right: 35px;
          top: 10px;
          border-radius: 20px;
          cursor: pointer;
          font-size: 12px;
          &:hover{
            background: #409EFF;
            color: #ffffff;
          }
        }
        .close{
          width: 20px;
          height: 20px;
          text-align: center;
          line-height: 20px;
          position: absolute;
          right: 10px;
          top: 10px;
          border-radius: 20px;
          cursor: pointer;
          font-size: 12px;
          &:hover{
            background: #F56C6C;
            color: #ffffff;
          }
        }
      }
      .task-foot{
        padding: 0 10px 10px 10px;
        font-size: 12px;
        border-top: 1px solid #ebebeb;
        &:after{
          display: table;
          content: "";
          clear: both;
        }
        .tit{
          float: left;
          height: 28px;
          padding-top: 4px;
        }
        .c{
          float: left;
          width: 16px;
          height: 16px;
          text-align: center;
          line-height: 16px;
          border-radius: 50%;
          background: #67C23A;
          color: #fff;
          font-weight: bold;
          font-size: 11px;
          margin-top: 12px;
          margin-right: 10px;
          &:last-child{
            margin-right: 0;
          }
        }
      }
    }
    .task-green{
      box-shadow: 0 2px 12px 0 rgba(103, 194, 58,0.6);
    }
  }
}
</style>
